import { gql } from '@apollo/client';

import { ResponsiveImageFragment } from 'approot/shared/graphql/responsive-images/responsive-images.graphql';

export const interactiveContentStyleBackgroundFragment = gql`
  fragment InteractiveContentStyleBackground on ActivitiesStyles {
    sectionBackgroundStyles {
      sectionId
      backgroundColour
      backgroundImage {
        ...ResponsiveImageFragment
      }
    }
    defaultBackgroundStyle {
      backgroundColour
      backgroundImage {
        ...ResponsiveImageFragment
      }
    }
  }
  ${ResponsiveImageFragment}
`;

export const UPDATE_LESSON_ACTIVITIES_DEFAULT_BACKGROUND_STYLE = gql`
  mutation UpdateLessonActivitiesDefaultBackgroundStyle(
    $input: UpdateDefaultBackgroundStyleInput!
  ) {
    updateLessonActivitiesDefaultBackgroundStyle(input: $input) {
      id
      language
      styles {
        ...InteractiveContentStyleBackground
      }
    }
  }
  ${interactiveContentStyleBackgroundFragment}
`;
